module.exports = {
	// api: 'https://api-voucher-viva.onwardsmg.com/v1',
	// api: 'https://cdn.craffview.com/v1', // prod
	api: `${process.env.REACT_APP_BAMBOO_API || 'http://localhost:21506/v1'}`,
	// api: `${process.env.REACT_APP_BAMBOO_API || 'https://api-vivamax.craffview.com/v1'}`,
	// api: `${process.env.REACT_APP_BAMBOO_API || 'https://api-vivamax-uat.craffview.com/v1'}`,// UAT

	apiQuery: `${process.env.REACT_APP_QUERY_API || 'https://api2.craffview.com/v1'}`,
	apiAlarm: `${'https://api.craffview.com/v1'}`,
	// apiAlarm: `${'https://d3mgbr7exrskcr.cloudfront.net/v1'}`, // prod
	version: `${process.env.REACT_APP_VERSION || '1.00.00'}`,
	apiHeaderXCraffviewEnv: `${process.env.REACT_APP_BAMBOO_CRAFFVIEW_ENV || 'development'}`,
	accountId: `${process.env.REACT_APP_ACCOUNT_ID || 'vivamax'}`,
	domainSuffix: `${process.env.REACT_APP_DOMAIN_SUFFIX || '.vivamax.craffview.com'}`,
	// serviceAdmin: `${process.env.REACT_APP_SERVICE_ADMIN || 'https://vivamax.craffview.com/'}`,
	serviceAdmin: `${process.env.REACT_APP_SERVICE_ADMIN || 'https://vivamax-uat.craffview.com/'}`,// UAT

	// contentApiPath: process.env.CONTENT_API_PATH || 'https://api-dev.tbonx.com/',
	contentApiPath: process.env.CONTENT_API_PATH || 'https://api2.vivamax.net/',
	shortenLinkDomains: process.env.REACT_APP_SHORTENLINK_DOMAINS
		? JSON.parse(process.env.REACT_APP_SHORTENLINK_DOMAINS)
		: {
			VMX: {
				PROD: 'https://share.vivamax.net',
				STAG: 'https://share-viva-stag.onwardsmg.com',
				DEV: 'https://share-viva.onwardsmg.com',
			},
			Vivaone: {
				PROD: 'https://share.vivaone.ph',
				STAG: 'https://share-vivaone-stag.onwardsmg.com',
				DEV: 'https://share-vivaone.onwardsmg.com',
			},
			Club: {
				PROD: 'https://share.vmxclub.com',
				STAG: 'https://share-vmx-stag.onwardsmg.com',
				DEV: 'https://share-vmx-dev.onwardsmg.com',
			},
			VMB: {
				PROD: 'https://share.vivamoviebox.com',
				STAG: 'https://share-stag.vivamoviebox.com',
				DEV: 'https://share-dev.vivamoviebox.com',
			}
		},

	campaign_channels: process.env.REACT_APP_CAMPAIGN_CHANNELS
		? JSON.parse(process.env.REACT_APP_CAMPAIGN_CHANNELS)
		: ["Facebook", "IG", "Others"],

	shortenLinkActions: process.env.REACT_APP_SHORTENLINK_ACTIONS
		? JSON.parse(process.env.REACT_APP_SHORTENLINK_ACTIONS)
		: ["landOnDetailPage", "playContent", "playTrailer", "IAP"],

	notificationApps: process.env.REACT_APP_NOTIFICATION_APPS
		? JSON.parse(process.env.REACT_APP_NOTIFICATION_APPS)
		: [process.env.REACT_APP_ACCOUNT_ID || 'vivamax'],
	notificationTopics: process.env.REACT_APP_NOTIFICATION_TOPICS
		? JSON.parse(process.env.REACT_APP_NOTIFICATION_TOPICS)
		: [],
	notificationEnvs: process.env.REACT_APP_NOTIFICATION_ENVS
		? JSON.parse(process.env.REACT_APP_NOTIFICATION_ENVS)
		: ["PROD", "STAG", "DEV"],

	menus: process.env.REACT_APP_MENUS
		? JSON.parse(process.env.REACT_APP_MENUS)
		: ["/shortenLink", "/notification"],
};
